import React from 'react'
import { Box } from '@workwhile/ui'
import { useJetStatusContextValue } from '../context/JetStatusProvider'
import { JetStatusHeader } from './JetStatusHeader'
import { JetStatusSummary } from './JetStatusSummary'
import { JetStatusFilterBar } from './JetStatusFilterBar'
import { JetStatusTable } from './JetStatusTable'

export const JetStatusMain = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useJetStatusContextValue()

  return (
    <>
      <JetStatusHeader />
      <JetStatusSummary />
      <JetStatusFilterBar filters={filters} setFilters={setFilters} />
      <Box margin={3}>
        <JetStatusTable />
      </Box>
    </>
  )
}
